// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Card, Spin } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import './home.css';
import { END } from 'redux-saga';
//announcement api
import { announcementAPI } from 'services/home/home'

function Home(props) {
	const loggedIn = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
	const { givenName } = loggedIn;
	
    const [ isloading, setLoading ] = useState(true);
    const [announcementData, setAnnouncementData] = useState([]);

	async function getData(){
        try{
            const announcement = await announcementAPI();
            setAnnouncementData(announcement);

			if(announcement){
				setLoading(false);
			};

        }catch(error) {
            console.log("error", error);
        }
    };

    useEffect( ()=> {
        function fetchData() {
            getData();
        }
        fetchData();

    }, []);

	return (
		<div className="home-content">
			<div>
				<h1 className="home-content-user"> Hello, {givenName}!</h1>
			</div>
			{ isloading ? (
				<div className='spin-loading' >
					<Spin tip="Loading..." size='large'></Spin>
				</div>
				) : (
					<Card className="home-card" size="default">
						<h1 style={{ color: '#0487C8' }}> { announcementData.announcement_header } </h1>
						<p style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
							{ announcementData.announcement_content }
						</p>
					</Card>
				) 
			}
		</div>
	);
}

export default Home;
